<template>
  <v-container
    id="app-mobil-products"
    class="pa-1"
  >
    <screen
      :infoclass="solde ? 'green--text' : null"
      :title="solde ? $t('words.solde') : $t('words.amount')"
      :info="solde ? $amount(solde) : $amount(total)"
      :titlesup="solde ? $t('words.amount') : null"
      :infosup="solde ? $amount(total) : null"
    />

    <div
      v-if="products.length > 0"
      class="product-list mt-3"
      :class="solde ? 'bloc-action-small' : 'bloc-action'"
    >
      <mobil-product-key
        v-for="(product, j) in products"
        :key="j"
        :product="product"
        @add="click"
      />
    </div>
    <div
      v-else
      class="title text-center mt-5"
    >
      {{ $t('field.mobil.no_product') }}
    </div>

    <v-dialog
      v-model="dialog.show"
      persistent
      :content-class="dialog.class"
    >
      <v-card id="mobil-dialog">
        <v-card-title class="headline pb-0">
          {{ current.label }}
        </v-card-title>

        <v-card-text class="pt-1">
          <form @submit.prevent="addCurrent">
            <div
              v-show="dialog.error"
              class="info pa-1 text-center"
            >
              {{ dialog.error }}
            </div>
            <v-text-field
              v-model="dialog.quantity"
              :prepend-inner-icon="IconEnum.mobil_quantity"
              :label="$t('field.mobil.quantity') + (current.price === 0 ? ' *' : '')"
              :placeholder="current.quantity ? current.quantity.toString() : ''"
              type="number"
              inputmode="decimal"
              name="quantity"
              class="needsclick"
              @input="current.price > 0 ? dialog.total = null : null"
              @focus="focused"
              @blur="blured"
            />
            <v-text-field
              v-model="dialog.total"
              :prepend-inner-icon="IconEnum.mobil_total"
              :label="$t('field.mobil.total') + (current.price === 0 ? ' *' : '')"
              :placeholder="current.total ? $amount(current.total) : ''"
              type="number"
              inputmode="decimal"
              name="total"
              class="needsclick"
              @input="current.price > 0 ? dialog.quantity = null : null"
              @focus="focused"
              @blur="blured"
            />
            <input
              style="display: none"
              type="submit"
            >
          </form>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="error"
            name="back"
            class="btn"
            outlined
            @click="clearDialog"
          >
            Annuler
          </v-btn>
          <v-spacer />
          <v-btn
            color="success"
            name="add"
            class="btn"
            outlined
            @click="addCurrent"
          >
            {{ $t(current.quantity === 0 ? 'field.mobil.add' : 'field.mobil.edit') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <bottom-action
      name="mobil-bottom-action"
      btn-cancel
      btn-valid
      :btn-valid-disabled="total === 0"
      :btn-del-disabled="savedProducts.length === 0"
      :use-listener="false"
      @cancel="cancel"
      @del="del"
      @valid="valid"
    />
  </v-container>
</template>

<script>
import { ActionEnum, IconEnum } from '@/modules/Enums'
import { Scan } from '@/modules/Scan'

import MobilProductKey from '@/components/keyboard/product/MobilProductKey'
import { $alert, $amount, createReference } from '@/modules/Utils'

export default {
  name: 'MobilProductsView',

  components: {
    MobilProductKey
  },

  props: {
    badge: { type: Object, default: null },
    pme: { type: Object, default: null },
    productList: { type: Array, default: () => [] },
    previousTotal: { type: Number, default: null },
    previousList: { type: Array, default: () => [] },
    previousListSaved: { type: Array, default: () => [] },
    previousReference: { type: String, default: null },
    session: { type: String, default: null }
  },

  data () {
    return {
      IconEnum,
      //
      products: [],
      current: {},
      savedProducts: [],
      dialog: {
        show: false,
        total: null,
        quantity: null,
        error: null,
        class: ''
      },
      reference: null
    }
  },

  computed: {
    total: {
      get () { return this.$store.state.amount },
      set (val) { this.$store.commit('amount', val) }
    },
    solde () {
      return this.pme ? this.pme.Solde : (this.badge ? this.badge.Solde : null)
    },
    nbDecimals () {
      return this.$store.getters.currency.Decimales
    }
  },

  mounted () {
    if (this.badge === null && this.session === null) {
      this.$router.replace('/')
    } else {
      this.$emit('title', this.$i18n.t('title.mobil_products'))

      // Si réception d'une liste, affichage de celle-ci
      if (this.previousTotal !== null) {
        this.total = this.previousTotal
        this.products = this.previousList
        this.savedProducts = this.previousListSaved
        this.reference = this.previousReference
      } else {
        // Formattage de la liste à afficher
        this.productList.forEach((product, index) => {
          this.products.push({
            index: index,
            id: product.IDArticle,
            label: product.Libelle,
            description: product.Description,
            price: product.PrixUnitaireHT,
            priceTax: product.PrixUnitaireTTC,
            ref: product.Reference,
            quantity: product.Quantite ? product.Quantite : 0,
            total: product.Total ? product.Total : 0
          })
          if (product.Total) this.total += product.Total
        })
        this.reference = createReference()
      }
    }
  },

  methods: {
    $amount,
    focused () {
      if (IS_ANDROID) {
        this.dialog.class = 'dialog-top'
      }
    },
    blured () {
      if (IS_ANDROID) {
        this.dialog.class = ''
      }
    },
    //
    clearProductList () {
      this.total = 0
      this.savedProducts = []
      this.products.forEach(product => {
        product.total = 0
        product.quantity = 0
      })
    },
    clearDialog () {
      this.dialog = {
        show: false,
        total: null,
        quantity: null,
        error: null,
        class: ''
      }
      this.current = {}
    },
    focusField (field = 'quantity') {
      setTimeout(() => {
        document.getElementsByName(field)[0].focus()
      }, 200)
    },
    //
    click (product) {
      this.current = product
      this.dialog.show = true
      this.focusField()
    },
    addCurrent () {
      this.dialog.error = null

      // Formattage des champs
      let total = parseFloat(this.dialog.total)
      let quantity = parseFloat(this.dialog.quantity)

      total = (total === 0 || isNaN(total)) ? null : parseInt((total.toFixed(2) * Math.pow(10, this.nbDecimals)))
      quantity = (quantity === 0 || isNaN(quantity)) ? null : quantity.toFixed(3)

      // Contrôle formattage
      if (this.current.price === 0 && (total === null || quantity === null)) {
        this.dialog.error = this.$i18n.t('field.mobil.total_and')
        if (quantity !== null) {
          this.focusField('total')
        }
      } else if (this.current.price > 0 && total === null && quantity === null) {
        this.dialog.error = this.$i18n.t('field.mobil.total_or')
        this.focusField()
      } else {
        // Ajout produit
        if (this.current.price !== 0) {
          if (total) {
            quantity = (total / this.current.price).toFixed(3)
          } else {
            total = parseInt((quantity * this.current.price).toFixed(0))
          }
        }

        this.total += (total - this.current.total)
        this.current.total = total
        this.current.quantity = parseFloat(quantity)

        this.savedProducts.unshift({
          index: this.current.index,
          label: this.current.label,
          total: total,
          quantity: quantity
        })

        this.clearDialog()
      }
    },
    // ***** *****
    del () {
      if (this.total === 0) {
        this.$emit('title', this.$i18n.t('title.mobil_scan'))
        this.$router.replace({ name: 'scan-nfc', params: { action: ActionEnum.mobil, mode: 'P', backToHome: true } })
      } else {
        this.total -= this.savedProducts[0].total
        this.products[this.savedProducts[0].index].total -= this.savedProducts[0].total
        this.products[this.savedProducts[0].index].quantity -= this.savedProducts[0].quantity
        this.savedProducts.shift()
      }
    },
    cancel () {
      if (this.total === 0) {
        if (this.session) {
          window.close()
        } else {
          this.$router.replace('/home')
        }
      } else {
        this.clearProductList()
      }
    },
    valid () {
      if (this.session !== null) {
        Scan.launchEditionMobil(
          this.session,
          this.products,
          _ => {
            $alert(
              this.$i18n.t('field.mobil.success'),
              'success',
              '',
              0,
              [],
              () => {
                window.close()
              }
            )
          },
          $alert
        )
      } else {
        this.$router.replace({
          name: 'mobil-payment',
          params: {
            badge: this.badge,
            total: this.total,
            products: this.products,
            savedProducts: this.savedProducts,
            reference: this.reference
          }
        })
      }
    }
  }
}
</script>
